import { render, staticRenderFns } from "./ShoppingCartWidget.vue?vue&type=template&id=3192181f&scoped=true&"
import script from "./ShoppingCartWidget.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartWidget.vue?vue&type=style&index=0&id=3192181f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192181f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VCard,VIcon,VNavigationDrawer})
